import { Link, useLocation } from "wouter";
import { useState } from "react";
import { useMenu } from "context/MenuContext";
import { url, urlInv } from "Utils/DBHelper/Helper";
import apiService from 'Services/apiService';
import AlertNotification from "components/common/AlertNotification/AlertNotification";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import Logo from "assets/img/logo.svg";
import "../style.css";
import Loading from "components/common/Loading/Loading";

function ResponsiveNav({ SERVICES_LINKS, path, logout }) {
  const [, setLocation] = useLocation();
  const [alert, setAlert] = useState({ show: false, title: '', details: '', variant: 'Danger' });
  const { updateMenus } = useMenu();
  const storedUserType = localStorage.getItem('user') || '{}';
  const clientCod = JSON.parse(localStorage.getItem('cliCod') || 'null'); // Parsear correctamente el código del cliente

  const [array_menus, setArrayMenus] = useState(JSON.parse(storedUserType)?.array_menus || []);
  const [array_clients] = useState(JSON.parse(storedUserType)?.array_clients || []);
  const userName = JSON.parse(storedUserType)?.user?._nombre || 'Usuario';
  const [showLoadingComponent, setShowLoadingComponent] = useState(false);

  const switchTenant = (codClient) => {
    setShowLoadingComponent(true);
    apiService({
      name: 'switchTenan',
      queryParams: { _codigoCliente: codClient },
      useSpecialToken: true,
      onSuccess: ({ response }) => {
        // Procesar la respuesta
        const user = {
          codTipoCliente: response?.user?._codigoCliente,
          codUsuario: response?.user?._codigoCliente,
          correo: response?.user?._email,
          ...response
        };
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('cliCod', JSON.stringify(codClient));

        // Actualizar el array de menús y clientes
        setArrayMenus(response.array_menus || []);
        updateMenus(response.array_menus);
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error al realizar la acción.',
          details: error?.message,
          variant: 'Danger'
        });
      },
      onFinally() {
        setShowLoadingComponent(false);
        const originalPath = localStorage.getItem('originalPath') || '/';
        setLocation(originalPath);
      }
    });
  };

  const handleLogout = () => {
    // Llamar a la función de logout
    logout();

    // Limpiar el contexto de menús al cerrar sesión
    updateMenus([]);
  };

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  return (
    <>
      {showLoadingComponent && <Loading />}
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="#home">
            <Link to="/">
              <img
                src={Logo}
                alt="Logo Segurnet - Aniversario de quince años en el mercado"
                className="menu__logo"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              {
                array_menus?.length ?
                  array_menus?.map((ele) => (
                    <Link
                      key={ele._id}
                      to={JSON.parse(storedUserType)?.user?._tipoUsuario === 'Individual' ? urlInv[ele._id] : url[ele._id]}
                      className={`nav-link ${path === "/" + url[ele._id] ? 'active' : ''}`}
                    >
                      {ele._nomenclatura}
                    </Link>
                  )) : null
              }
              {(JSON.parse(storedUserType)?.user?._grupo !== "Productor" && array_clients?.length > 1) &&
                <NavDropdown title="Ver como" id="collapsible-nav-dropdown" className="ms-lg-5">
                  {array_clients?.map((ele) => (
                    <NavDropdown.Item
                      key={`${ele._id}-${ele._codigoCliente}`}
                      onClick={() => switchTenant(ele._codigoCliente)}
                      disabled={ele._codigoCliente === clientCod}
                      className={ele._codigoCliente === clientCod && "account-select"}
                    >
                      {ele._nombre}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              }
            </Nav>
            <Nav>
              <Dropdown className="ms-lg-5 no-arrow">
                {/* Custom Toggle */}
                <Dropdown.Toggle as="div" id="dropdown-custom-components" className="dropdown-text">
                  <span><b>{userName}</b></span>
                  { JSON.parse(storedUserType)?.user?._grupo !== "Productor" &&
                    <span className="account-name">
                      <small>{array_clients.find(client => client._codigoCliente === clientCod)?._nombre}</small>
                    </span>
                  }
                </Dropdown.Toggle>

                {/* Dropdown Items */}
                <Dropdown.Menu>
                  <Dropdown.Item as="div" className={`dropdown-user-name ${path === "/mi-perfil" ? 'active' : ''}`}>
                    <Link to="/mi-perfil" className="p-0 text-dark text-decoration-none">Perfil</Link>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogout}>
                    Cerrar sesión
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <AlertNotification
        show={alert?.show}
        title={alert?.title}
        details={alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
}

export default ResponsiveNav;
